import React from "react";
import './styles.css'

export default function Input({ value, onChange, type , inputMode}) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      inputMode={inputMode}
      style={{
        width: "95%",
        padding: "15px 15px",
        fontSize: "14px",
        border: "1px solid rgb(208, 208, 208)",
        borderRadius: "5px",

      }}
    />
  );
}
